import { createSearchParams, To } from "react-router-dom";
import Casino from "assets/icons/glory/tabbar_casino.svg?react";
import DepositGlory from "assets/icons/glory/tabbar_deposit.svg?react";
import DepositBanger from "assets/icons/banger/tabbar_deposit.svg?react";
import SupportIcon from "assets/icons/banger/support.svg?react";
import SportIcon from "assets/icons/sport.svg?react";
import Tournament from "assets/icons/glory/burger_tournament.svg?react";
import url from "url/index";
import NavTrigger from "../../components/atoms/MenuWithClose";
import { GET_PARAMS, GET_POPUP_TYPES } from "../popupConfig";

const { VITE_APP_PROJECT_NAME } = import.meta.env;

export enum TABBAR_NAVIGATION_ENUM {
  MENU,
  CASINO,
  DEPOSIT,
  TOURNAMENT,
  FAVORITE,
  SUPPORT,
  SPORT,
}

export type TabbarType = {
  id: TABBAR_NAVIGATION_ENUM;
  title: string;
  icon: JSX.Element;
  location: To;
};

export const TABBAR_NAVIGATION_LIST: TabbarType[] = [
  {
    id: TABBAR_NAVIGATION_ENUM.MENU,
    icon: <NavTrigger />,
    title: "menu.left.menu",
    location: {
      search: `?${createSearchParams({
        [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.sideMenu,
      })}`,
    },
  },
  {
    id: TABBAR_NAVIGATION_ENUM.CASINO,
    icon: <Casino />,
    title: "footer.casino",
    location: url.routes.casino.index(),
  },
  {
    id: TABBAR_NAVIGATION_ENUM.DEPOSIT,
    icon:
      VITE_APP_PROJECT_NAME === "glory" ? <DepositGlory /> : <DepositBanger />,
    title: "menu.left.deposit",
    location: {
      search: `?${createSearchParams({
        [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.deposit,
      })}`,
    },
  },

  {
    id: TABBAR_NAVIGATION_ENUM.TOURNAMENT,
    icon: <Tournament />,
    title: "menu.left.tournament",
    location: url.routes.tournament.index(),
  },
  {
    id: TABBAR_NAVIGATION_ENUM.SPORT,
    icon: <SportIcon />,
    title: "casino.top.sports",
    location: url.config.casino.sportsBook,
  },
  //   {
  //     id: TABBAR_NAVIGATION_ENUM.FAVORITE,
  //     icon: <Favorite />,
  //     title: "casino.sidebar.favorite",
  //     location: url.routes.casino.favorites(),
  //   },
  {
    id: TABBAR_NAVIGATION_ENUM.SUPPORT,
    icon: <SupportIcon />,
    title: "footer.support.header",
    location: "#",
  },
];
